import styled from "styled-components/macro";

export default styled.div`
  background-image: url('/contact.jpg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 300px;
`;
